import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DesignEditorAuxiliaryControlBar } from '../../../../DesignEditor/components/DesignEditorControls';
import { CARD_ELEMENT_TYPE } from '../../../../../../services/cards/constants';
import CardDesignerCardElementCommonControls from './components/CardDesignerCardElementCommonControls/CardDesignerCardElementCommonControls';
import CardDesignerCardElementTextControls from '../CardDesignerCardElementText/CardDesignerCardElementTextControls';
import CardDesignerCardElementRectangleControls from '../CardDesignerCardElementRectangle/CardDesignerCardElementRectangleControls';
import { isElementCardLogo } from '../../CardDesignerControlPanel/components/CardDesignerLogoControls/helpers';
import { DESIGN_MODES } from '../../../constants';

const propTypes = {
  className: PropTypes.string,
  element: PropTypes.shape({
    cardElement: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    cardElementConfiguration: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }),
  onCardElementCreate: PropTypes.func.isRequired,
  onCardElementUpdate: PropTypes.func.isRequired,
  onCardElementDelete: PropTypes.func.isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
  designMode: PropTypes.oneOf(Object.values(DESIGN_MODES)).isRequired,
  cardSide: PropTypes.object,
  setLastUsedFont: PropTypes.func.isRequired,
};

const CardDesignerCardElementControlToolbar = ({
  className,
  element,
  onCardElementCreate,
  onCardElementUpdate,
  onCardElementDelete,
  onElementConfigurationChange,
  designMode,
  cardSide,
  setLastUsedFont,
}) => {
  const classes = classNames({
    'card-designer-card-element-control-toolbar': true,
    [className]: !!className,
  });

  if (!element) {
    return <DesignEditorAuxiliaryControlBar className={classes} />;
  }

  const { cardElement } = element;
  const isLogo = isElementCardLogo(element);
  const { card_template: cardTemplate } = cardSide ?? {};

  const renderCardElementControls = () => {
    if (cardElement.type === CARD_ELEMENT_TYPE.TEXT) {
      return (
        <CardDesignerCardElementTextControls
          key={element.cardElement.id}
          onCardElementUpdate={onCardElementUpdate}
          onElementConfigurationChange={onElementConfigurationChange}
          setLastUsedFont={setLastUsedFont}
          element={element}
        />
      );
    }

    if (cardElement.type === CARD_ELEMENT_TYPE.RECTANGLE) {
      return (
        <CardDesignerCardElementRectangleControls
          key={element.cardElement.id}
          onCardElementUpdate={onCardElementUpdate}
          onElementConfigurationChange={onElementConfigurationChange}
          element={element}
        />
      );
    }

    return null;
  };

  return (
    <DesignEditorAuxiliaryControlBar
      className={classes}
      contentLeft={renderCardElementControls()}
      contentRight={
        isLogo ? undefined : (
          <CardDesignerCardElementCommonControls
            element={element}
            onCardElementCreate={onCardElementCreate}
            onCardElementDelete={onCardElementDelete}
            onCardElementUpdate={onCardElementUpdate}
            onElementConfigurationChange={onElementConfigurationChange}
            designMode={designMode}
            cardTemplate={cardTemplate}
          />
        )
      }
    />
  );
};

CardDesignerCardElementControlToolbar.propTypes = propTypes;

export default CardDesignerCardElementControlToolbar;
